import * as React from 'react';
import { SVGProps } from 'react';

const IconWindowSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 5.5h6v1H3v-1ZM3 7.5h3v1H3v-1Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm0 3v6h8V4H2Z"
    />
  </svg>
);
export default IconWindowSizeXs;
